'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoHelpCircled = function IoHelpCircled(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 2.5c9.7 0 17.5 7.8 17.5 17.5s-7.8 17.5-17.5 17.5-17.5-7.8-17.5-17.5 7.8-17.5 17.5-17.5z m1.6 25.5c0-1.4-1-2.4-2.3-2.4-1.3 0-2.3 0.9-2.3 2.3s0.9 2.3 2.1 2.3c1.4 0 2.5-0.7 2.5-2.2z m3.8-10c0.5-0.7 0.9-1.7 0.9-2.8 0-1.8-0.7-3.1-1.9-4-1.4-1-2.9-1.4-4.9-1.4-1.5 0-2.6 0.3-3.6 1-1.5 1-2.2 2.6-2.2 5.3h3.8c0-0.7-0.1-1.5 0.3-2.1s1-1.2 2-1.2 1.5 0.2 2 0.9c0.4 0.5 0.6 1.1 0.6 1.8 0 0.5-0.3 1.1-0.6 1.5-0.2 0.3-0.5 0.6-0.8 0.8 0 0-2 1.2-2.7 2.4-0.6 0.8-0.7 1.8-0.8 3.2 0 0 0 0.3 0.3 0.3h3.1s0.4-0.3 0.4-0.3c0-0.5 0-1.2 0.1-1.5 0.2-0.6 0.5-1 0.9-1.4l1.1-0.7c1-0.7 1.7-1.3 2-1.8z' })
        )
    );
};

exports.default = IoHelpCircled;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/help-circled.js
// module id = 2527
// module chunks = 168707334958949